import React, { useState, useEffect } from 'react';

const CurrencyTextField = ({ initialCurrencySymbol = '$', initialCurrencyValue = 1000, onCurrencyChange, currencyList,disabled = false }) => {
    const [currencyInput, setCurrencyInput] = useState(''); // Input field state
    const [currencySymbol, setCurrencySymbol] = useState(initialCurrencySymbol); // Extracted currency symbol
    const [currencyValue, setCurrencyValue] = useState(initialCurrencyValue); // Extracted numeric value
    const currencyRegex = new RegExp(
        `^(${currencyList.map((symbol) => `\\${symbol.vc_CurrencySymbol}`).join('|')})`
    );
    // Initialize the field with the given data on component mount
    useEffect(() => {
       const formattedValue = (initialCurrencyValue || 0).toLocaleString();
        setCurrencyInput(`${initialCurrencySymbol}${formattedValue}`);
        setCurrencySymbol(initialCurrencySymbol);
        setCurrencyValue(formattedValue);
    }, [initialCurrencySymbol, initialCurrencyValue]);
    
    // Handle input changes
    const handleInputChange = (e) => {
        const input = e.target.value;
        setCurrencyInput(input); // Set the raw input

        const symbolMatch = input.match(currencyRegex);// Matches common currency symbols
        const valueMatch = input.match(/[\d,]+(\.\d{1,2})?/); // Matches numeric value (with optional decimals)

        // Update the extracted currency symbol
        if (symbolMatch) {
            setCurrencySymbol(symbolMatch[0]); // Set the currency symbol
        } else {
            setCurrencySymbol(''); // Clear if no match
        }
        
        // Update the extracted numeric value
        if (valueMatch) {
            const cleanedValue = valueMatch[0].replace(/,/g, ''); // Remove commas for formatting
            setCurrencyValue(cleanedValue); // Set the numeric value
        } else {
            setCurrencyValue('0.00'); // Clear if no match
        }
        if (onCurrencyChange) {
            onCurrencyChange({
                symbol: symbolMatch ? symbolMatch[0] : '',
                value: valueMatch ? valueMatch[0].replace(/,/g, '') : ''
            });
        }
    };

    return (
        <input
        type="text"
        className="form-control"
        value={currencyInput}
        onChange={handleInputChange}
        disabled={disabled}

    />
    );
};

// Export the component
export default CurrencyTextField;
